import React from "react";

const LeaveProjectModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  loading, 
  success,    // Received from parent
  buttonText  // Received from parent (e.g., "Leaving...", "Left")
}) => {
  if (!isOpen) return null;

  // Determine button background color based on state
  const getButtonStyles = () => {
    if (success) return "bg-[#E95353] text-white border-[#E95353]"; // Success state (Red background)
    if (loading) return "bg-[#E95353] text-white border-[#E95353]"; // Loading state (Red background)
    return "border border-[#E4E4E7] text-[#52525B] hover:text-white hover:bg-[#E95353] hover:border-[#E95353]"; // Default state
  };

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-[8px] shadow-xl w-[550px] px-8 py-5 relative flex flex-col items-center text-center animate-fadeIn">
        
        {/* Modal Content */}
        <h2 className="text-[#18181B] font-outfit text-[22px] font-semibold mb-3">
          Are you sure you want to leave the project?
        </h2>
        
        <p className="text-[#71717A] font-outfit text-[16px] font-normal leading-6 mb-6 max-w-[500px]">
          If you leave, this project will be removed from your workspace.
          This action cannot be undone.
        </p>

        {/* Buttons */}
        <div className="flex items-center gap-4 w-full justify-center">
          <button
            onClick={onClose}
            disabled={loading || success} // Disable cancel during loading/success
            className="w-[140px] h-[44px] rounded-[8px] border border-[#C95EBE] text-[#C95EBE] font-outfit text-[16px] font-medium hover:text-white hover:bg-[#C95EBE] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          
          <button
            onClick={onConfirm}
            disabled={loading || success}
            className={`w-[140px] h-[44px] rounded-[8px] font-outfit text-[16px] font-medium transition-colors flex items-center justify-center disabled:opacity-80 disabled:cursor-not-allowed ${getButtonStyles()}`}
          >
            {loading ? (
              <div className="flex items-center gap-2">
                <span>{buttonText || "Leaving..."}</span>
              </div>
            ) : (
              buttonText || "Leave"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeaveProjectModal;
